// extracted by mini-css-extract-plugin
module.exports = {"container":"done-module__container___3Na5p","content":"done-module__content___1G0iR","text":"done-module__text___e1vLt","link":"done-module__link___1OGib"};